import React from 'react';
import { ToggleButton as BSToggleButton, ToggleButtonProps as BSToggleButtonProps } from 'react-bootstrap';

export interface ToggleButtonProps extends BSToggleButtonProps {

}

export const ToggleButton: React.FC<ToggleButtonProps> = (props) => {
    return <BSToggleButton {...props}>{props.children}</BSToggleButton>;
}

(ToggleButton as any).displayName = 'ToggleButton'